import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TvoRoutingModule } from './tvo-routing.module';
import { TvoComponent } from './tvo.component';
import { SharedModule } from '../shared/shared.module';
import { TVO_SERVICE, TvoRequestsService } from './services/tvo-requests.service';
import { AccessControlModule } from '../core/access-control/access-control.module';

@NgModule({
  declarations: [TvoComponent],
  imports: [CommonModule, TvoRoutingModule, SharedModule, AccessControlModule],
  providers: [
    {
      provide: TVO_SERVICE,
      useClass: TvoRequestsService,
    },
  ],
})
export class TvoModule {}
